"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sessionEstimateItemTitles = exports.SessionEstimateItemUnitType = void 0;
const session_activity_types_1 = require("./session-activity-types");
const session_types_1 = require("./session-types");
/**
 * Estimate Unit Types
 */
var SessionEstimateItemUnitType;
(function (SessionEstimateItemUnitType) {
    SessionEstimateItemUnitType["Hours"] = "hours";
    SessionEstimateItemUnitType["Miles"] = "miles";
    SessionEstimateItemUnitType["Days"] = "days";
    SessionEstimateItemUnitType["Count"] = "count";
    SessionEstimateItemUnitType["CostumeChanges"] = "costume changes";
    SessionEstimateItemUnitType["Tags"] = "tags";
    SessionEstimateItemUnitType["Doubles"] = "doubles";
})(SessionEstimateItemUnitType || (exports.SessionEstimateItemUnitType = SessionEstimateItemUnitType = {}));
/**
 * Titles
 */
// Web version
exports.sessionEstimateItemTitles = {
    [session_activity_types_1.WorkTimeType.StraightTime]: 'Straight Time',
    [session_activity_types_1.WorkTimeType.TimeAndOneHalf]: 'Overtime (Time-and-one-half)',
    [session_activity_types_1.WorkTimeType.DoubleTime]: 'Overtime (Double Time)',
    [session_activity_types_1.WorkTimeType.NoServiceDay]: 'Travel (No Service Day)',
    [session_activity_types_1.SessionActivityType.WorkTimeSaturday]: '(Saturday Premium)',
    [session_activity_types_1.SessionActivityType.WorkTimeSunday]: '(Sunday Premium)',
    [session_activity_types_1.SessionActivityType.WorkTimeHoliday]: '(Holiday Premium)',
    [session_types_1.SessionDayType.Saturday]: '(Saturday Premium)', // from api version
    [session_types_1.SessionDayType.Sunday]: '(Sunday Premium)', // from api version
    [session_types_1.SessionDayType.Holiday]: '(Holiday Premium)', // from api version
    Weekend: '(Weekend Premium)',
    [session_activity_types_1.SessionActivityType.WorkTimeNight]: '(Night Premium)',
    [session_activity_types_1.SessionActivityType.WorkTimeLateNight]: '(Late Night Premium)',
    [session_activity_types_1.SessionActivityType.TravelToLocationAfterMidnight]: '(Travel After Midnight)',
    [session_activity_types_1.SessionActivityType.TravelFromLocationAfterMidnight]: '(Travel After Midnight)',
    [session_activity_types_1.SessionActivityTimeOfDay.Night]: '(Night Premium)', // from api version
    [session_activity_types_1.SessionActivityTimeOfDay.LateNight]: '(Late Night Premium)', // from api version
    [session_activity_types_1.SessionActivityTimeOfDay.AfterMidnight]: '(Travel After Midnight)', // from api version
};
// API version
// export const sessionEstimateItemTitles: Record<string, string> = {
//   [WorkTimeType.StraightTime]: 'Straight Time',
//   [WorkTimeType.TimeAndOneHalf]: 'Overtime (Time-and-one-half)',
//   [WorkTimeType.DoubleTime]: 'Overtime (Double Time)',
//   [WorkTimeType.NoServiceDay]: 'Travel (No Service Day)',
//   [SessionDayType.Saturday]: '(Saturday Premium)',
//   [SessionDayType.Sunday]: '(Sunday Premium)',
//   [SessionDayType.Holiday]: '(Holiday Premium)',
//   Weekend: '(Weekend Premium)',
//   [SessionActivityTimeOfDay.Night]: '(Night Premium)',
//   [SessionActivityTimeOfDay.LateNight]: '(Late Night Premium)',
//   [SessionActivityTimeOfDay.AfterMidnight]: '(Travel After Midnight)',
// };
//# sourceMappingURL=session-estimate-item-types.js.map